import { useEffect, useCallback } from 'react';

// Custom helper hook to handle dropdown positioning of Google Places Autocomplete to remove watermark
// and give it same styling as the app's dropdowns
export const useDropdownPosition = (input: HTMLInputElement | null) => {
  const updateDropdownPosition = useCallback(() => {
    requestAnimationFrame(() => {
      const pacContainer = document.querySelector('.pac-container') as HTMLElement;
      if (pacContainer && input) {
        const rect = input.getBoundingClientRect();
        pacContainer.style.setProperty('--width', `${rect.width + 42}px`);
        pacContainer.style.setProperty('--left', `${rect.left - 20}px`);
        pacContainer.style.setProperty('--top', `${rect.top}px`);
      }
    });
  }, [input]);

  useEffect(() => {
    if (!input) return undefined;

    const resizeObserver = new ResizeObserver(updateDropdownPosition);
    resizeObserver.observe(input);
    input.addEventListener('focus', updateDropdownPosition);

    const handleInput = () => setTimeout(updateDropdownPosition, 100);
    input.addEventListener('input', handleInput);

    return () => {
      resizeObserver.disconnect();
      input.removeEventListener('focus', updateDropdownPosition);
      input.removeEventListener('input', handleInput);
    };
  }, [input, updateDropdownPosition]);

  return updateDropdownPosition;
};
